module.exports = __webpack_public_path__ + "media/images/talk-cb76671587d4658e14a102c51a99a0d5.svg";